import Banner from "../components/Contact/Banner/Banner";
import HelmetLayout from "../components/GlobalComponents/HelmetLayout";

const Contact = () => {
    return (
        <HelmetLayout
            name="Contact Us"
            title="Contact Ard Altaamir | Certified Service & Quality Guarantee"
            description="Contact Ard Altaamir for certified renovation, plumbing, and electrical services. Get expert advice, quick assistance, and a full workmanship guarantee on every project."
            route="contact"
        >
            <Banner />
        </HelmetLayout>
    );
};

export default Contact;
